import { useTranslation } from "react-i18next";
import { LayoutGrid } from "lucide-react";

import { Button } from "@/components/ui/button";

interface EmptyCanvasProps {
  onCustomize: () => void;
}

/**
 * Shown when the user has removed every widget. Not an error — an empty canvas is
 * a legitimate choice, so this stays quiet, says what the region is for, and
 * offers the way back.
 */
export const EmptyCanvas = ({ onCustomize }: EmptyCanvasProps) => {
  const { t } = useTranslation(["common"]);

  return (
    <div className="widget-slot flex h-52 flex-col items-center justify-center gap-2 px-6 text-center">
      <span className="widget-app-chip grid size-11 place-items-center [--widget-accent:var(--color-primary)]">
        <LayoutGrid size={18} aria-hidden />
      </span>
      <p className="text-sm font-semibold text-foreground">
        {t("common:dashboard_grid.overview_is_empty")}
      </p>
      <p className="max-w-sm text-xs text-muted-foreground">
        {t("common:dashboard_grid.empty_canvas_body")}
      </p>
      <Button variant="outline-primary" size="sm" onClick={onCustomize}>
        {t("common:dashboard_grid.add_widgets")}
      </Button>
    </div>
  );
};
